import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

import { AuthProvider } from "./AuthContext";

import Signup from "./pages/Signup";
import Login from "./pages/Login";
import GoogleAuthCallback from "./components/GoogleAuthCallback";
import { Home } from "./pages/Home";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { CarbonFootprint } from "./pages/CarbonFootprint";
import ContactUs from "./pages/ContactUs";
import { UserDashBoard } from "./pages/UserDashBoard";
import OurTeam from "./pages/OurTeam";
import Facts from "./pages/Facts";

import AdminDashboard from "./pages/AdminDashboard";
import AdminOverview from "./pages/AdminOverview";

// Real, fully-built components — import directly from their own files.
import AdminCertificates from "./pages/AdminCertificates";
import AdminVehicles from "./pages/AdminVehicles";
import AdminUsers from "./pages/AdminUsers";
import AdminReports from "./pages/AdminReports";
import AdminImpact from "./pages/AdminImpact";
import AdminDownloads from "./pages/AdminDownloads";
import AdminSettings from "./pages/AdminSettings";

function App() {
  return (
    <Router>
      <AuthProvider>
        <Layout />
      </AuthProvider>
    </Router>
  );
}

const Layout = () => {
  const location = useLocation();

  const path = location.pathname.toLowerCase();
  const hideLayout =
    path.startsWith("/admindashboard") ||
    path.startsWith("/userdashboard") ||
    path.startsWith("/login") ||
    path.startsWith("/signup");

  return (
    <>
      {!hideLayout && <Navbar />}
      <MainRoutes />
      {!hideLayout && <Footer />}
    </>
  );
};

// Get logged-in user
const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user"));
  } catch {
    return null;
  }
};

// Protected Admin Route
const AdminRoute = ({ children }) => {
  const user = getUser();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.role !== "admin") {
    return <Navigate to="/UserDashBoard" replace />;
  }

  return children;
};

// Protected User Route
const UserRoute = ({ children }) => {
  const user = getUser();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.role === "admin") {
    return <Navigate to="/AdminDashboard" replace />;
  }

  return children;
};

const MainRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<Home />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth/google/callback" element={<GoogleAuthCallback />} />
      <Route path="/carbonfootprint" element={<CarbonFootprint />} />
      <Route path="/ContactUs" element={<ContactUs />} />
      <Route path="/ourteam" element={<OurTeam />} />
      <Route path="/Facts" element={<Facts />} />

      {/* User Dashboard */}
      <Route
        path="/UserDashBoard"
        element={
          <UserRoute>
            <UserDashBoard />
          </UserRoute>
        }
      />

      {/* Admin Dashboard */}
      <Route
        path="/AdminDashboard"
        element={
          <AdminRoute>
            <AdminDashboard />
          </AdminRoute>
        }
      >
        <Route index element={<AdminOverview />} />
        <Route path="certificates" element={<AdminCertificates />} />
        <Route path="vehicles" element={<AdminVehicles />} />
        <Route path="users" element={<AdminUsers />} />
        <Route path="reports" element={<AdminReports />} />
        <Route path="impact" element={<AdminImpact />} />
        <Route path="downloads" element={<AdminDownloads />} />
        <Route path="settings" element={<AdminSettings />} />
      </Route>

      {/* 404 */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default App;

// import React from "react";
// import {
//   BrowserRouter as Router,
//   Routes,
//   Route,
//   Navigate,
//   useLocation,
// } from "react-router-dom";

// import { AuthProvider } from "./AuthContext";

// import Signup from "./pages/Signup";
// import Login from "./pages/Login";
// import GoogleAuthCallback from "./components/GoogleAuthCallback";
// import { Home } from "./pages/Home";
// import { Navbar } from "./components/Navbar";
// import { Footer } from "./components/Footer";
// import { CarbonFootprint } from "./pages/CarbonFootprint";
// import ContactUs from "./pages/ContactUs";
// import { UserDashBoard } from "./pages/UserDashBoard";
// import OurTeam from "./pages/OurTeam";
// import Facts from "./pages/Facts";

// import AdminDashboard from "./pages/AdminDashboard";
// import AdminOverview from "./pages/AdminOverview";

// // Real, fully-built components — import directly from their own files.
// import AdminCertificates from "./pages/AdminCertificates";
// import AdminVehicles from "./pages/AdminVehicles";

// // Still-placeholder pages only.
// import {
//   AdminUsers,
//   AdminReports,
//   AdminImpact,
//   AdminDownloads,
//   AdminSettings,
// } from "./pages/AdminPlaceholderPages";

// function App() {
//   return (
//     <Router>
//       <AuthProvider>
//         <Layout />
//       </AuthProvider>
//     </Router>
//   );
// }

// const Layout = () => {
//   const location = useLocation();

//   const hideLayout =
//     location.pathname.startsWith("/AdminDashboard") ||
//     location.pathname.startsWith("/UserDashBoard");

//   return (
//     <>
//       {!hideLayout && <Navbar />}
//       <MainRoutes />
//       {!hideLayout && <Footer />}
//     </>
//   );
// };

// // Get logged-in user
// const getUser = () => {
//   try {
//     return JSON.parse(localStorage.getItem("user"));
//   } catch {
//     return null;
//   }
// };

// // Protected Admin Route
// const AdminRoute = ({ children }) => {
//   const user = getUser();

//   if (!user) {
//     return <Navigate to="/login" replace />;
//   }

//   if (user.role !== "admin") {
//     return <Navigate to="/UserDashBoard" replace />;
//   }

//   return children;
// };

// // Protected User Route
// const UserRoute = ({ children }) => {
//   const user = getUser();

//   if (!user) {
//     return <Navigate to="/login" replace />;
//   }

//   if (user.role === "admin") {
//     return <Navigate to="/AdminDashboard" replace />;
//   }

//   return children;
// };

// const MainRoutes = () => {
//   return (
//     <Routes>
//       {/* Public Routes */}
//       <Route path="/" element={<Home />} />
//       <Route path="/signup" element={<Signup />} />
//       <Route path="/login" element={<Login />} />
//       <Route path="/auth/google/callback" element={<GoogleAuthCallback />} />
//       <Route path="/carbonfootprint" element={<CarbonFootprint />} />
//       <Route path="/ContactUs" element={<ContactUs />} />
//       <Route path="/ourteam" element={<OurTeam />} />
//       <Route path="/Facts" element={<Facts />} />

//       {/* User Dashboard */}
//       <Route
//         path="/UserDashBoard"
//         element={
//           <UserRoute>
//             <UserDashBoard />
//           </UserRoute>
//         }
//       />

//       {/* Admin Dashboard */}
//       <Route
//         path="/AdminDashboard"
//         element={
//           <AdminRoute>
//             <AdminDashboard />
//           </AdminRoute>
//         }
//       >
//         <Route index element={<AdminOverview />} />
//         <Route path="certificates" element={<AdminCertificates />} />
//         <Route path="vehicles" element={<AdminVehicles />} />
//         <Route path="users" element={<AdminUsers />} />
//         <Route path="reports" element={<AdminReports />} />
//         <Route path="impact" element={<AdminImpact />} />
//         <Route path="downloads" element={<AdminDownloads />} />
//         <Route path="settings" element={<AdminSettings />} />
//       </Route>

//       {/* 404 */}
//       <Route path="*" element={<Navigate to="/" replace />} />
//     </Routes>
//   );
// };

// export default App;

// import React from "react";
// import {
//   BrowserRouter as Router,
//   Routes,
//   Route,
//   Navigate,
//   useLocation,
// } from "react-router-dom";

// import { AuthProvider } from "./AuthContext";

// import Signup from "./pages/Signup";
// import Login from "./pages/Login";
// import GoogleAuthCallback from "./components/GoogleAuthCallback";
// import { Home } from "./pages/Home";
// import { Navbar } from "./components/Navbar";
// import { Footer } from "./components/Footer";
// import { CarbonFootprint } from "./pages/CarbonFootprint";
// import ContactUs from "./pages/ContactUs";
// import { UserDashBoard } from "./pages/UserDashBoard";
// import OurTeam from "./pages/OurTeam";
// import Facts from "./pages/Facts";

// import AdminDashboard from "./pages/AdminDashboard";
// import AdminOverview from "./pages/AdminOverview";
// import {
//   AdminCertificates,
//   AdminVehicles,
//   AdminUsers,
//   AdminReports,
//   AdminImpact,
//   AdminDownloads,
//   AdminSettings,
// } from "./pages/AdminPlaceholderPages";

// function App() {
//   return (
//     <Router>
//       <AuthProvider>
//         <Layout />
//       </AuthProvider>
//     </Router>
//   );
// }

// const Layout = () => {
//   const location = useLocation();

//   const hideLayout =
//     location.pathname.startsWith("/AdminDashboard") ||
//     location.pathname.startsWith("/UserDashBoard");

//   return (
//     <>
//       {!hideLayout && <Navbar />}
//       <MainRoutes />
//       {!hideLayout && <Footer />}
//     </>
//   );
// };

// // Get logged-in user
// const getUser = () => {
//   try {
//     return JSON.parse(localStorage.getItem("user"));
//   } catch {
//     return null;
//   }
// };

// // Protected Admin Route
// const AdminRoute = ({ children }) => {
//   const user = getUser();

//   if (!user) {
//     return <Navigate to="/login" replace />;
//   }

//   if (user.role !== "admin") {
//     return <Navigate to="/UserDashBoard" replace />;
//   }

//   return children;
// };

// // Protected User Route
// const UserRoute = ({ children }) => {
//   const user = getUser();

//   if (!user) {
//     return <Navigate to="/login" replace />;
//   }

//   if (user.role === "admin") {
//     return <Navigate to="/AdminDashboard" replace />;
//   }

//   return children;
// };

// const MainRoutes = () => {
//   return (
//     <Routes>
//       {/* Public Routes */}
//       <Route path="/" element={<Home />} />
//       <Route path="/signup" element={<Signup />} />
//       <Route path="/login" element={<Login />} />
//       <Route path="/auth/google/callback" element={<GoogleAuthCallback />} />
//       <Route path="/carbonfootprint" element={<CarbonFootprint />} />
//       <Route path="/ContactUs" element={<ContactUs />} />
//       <Route path="/ourteam" element={<OurTeam />} />
//       <Route path="/Facts" element={<Facts />} />

//       {/* User Dashboard */}
//       <Route
//         path="/UserDashBoard"
//         element={
//           <UserRoute>
//             <UserDashBoard />
//           </UserRoute>
//         }
//       />

//       {/* Admin Dashboard */}
//       <Route
//         path="/AdminDashboard"
//         element={
//           <AdminRoute>
//             <AdminDashboard />
//           </AdminRoute>
//         }
//       >
//         <Route index element={<AdminOverview />} />
//         <Route path="certificates" element={<AdminCertificates />} />
//         <Route path="vehicles" element={<AdminVehicles />} />
//         <Route path="users" element={<AdminUsers />} />
//         <Route path="reports" element={<AdminReports />} />
//         <Route path="impact" element={<AdminImpact />} />
//         <Route path="downloads" element={<AdminDownloads />} />
//         <Route path="settings" element={<AdminSettings />} />
//       </Route>

//       {/* 404 */}
//       <Route path="*" element={<Navigate to="/" replace />} />
//     </Routes>
//   );
// };

// export default App;

// import React from "react";
// import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
// import { AuthProvider } from "./AuthContext";
// import Signup from "./pages/Signup";
// import Login from "./pages/Login";
// import GoogleAuthCallback from "./components/GoogleAuthCallback";
// import { Home } from "./pages/Home";
// import { Navbar } from "./components/Navbar";
// import { Footer } from "./components/Footer";
// import { CarbonFootprint } from "./pages/CarbonFootprint";
// import ContactUs from "./pages/ContactUs";
// import { UserDashBoard } from "./pages/UserDashBoard";

// import OurTeam from "./pages/OurTeam";
// import Facts from "./pages/Facts";
// import AdminDashboard from "./pages/AdminDashboard";
// import AdminOverview from "./pages/AdminOverview";
// import {
//   AdminCertificates,
//   AdminVehicles,
//   AdminUsers,
//   AdminReports,
//   AdminImpact,
//   AdminDownloads,
//   AdminSettings,
// } from "./pages/AdminPlaceholderPages";

// function App() {
//   return (
//     <Router>
//       <AuthProvider>
//         <Layout />
//       </AuthProvider>
//     </Router>
//   );
// }

// // ✅ Component that decides whether to show Navbar/Footer
// const Layout = () => {
//   const location = useLocation();

//   // Prefix-matched so nested admin routes (e.g. /AdminDashboard/vehicles)
//   // also hide the public Navbar/Footer.
//   const hideLayoutRoutes = ["/AdminDashboard", "/UserDashBoard"];
//   const hideLayout = hideLayoutRoutes.some((path) =>
//     location.pathname.startsWith(path)
//   );

//   return (
//     <>
//       {!hideLayout && <Navbar />}
//       <MainRoutes />
//       {!hideLayout && <Footer />}
//     </>
//   );
// };

// const MainRoutes = () => {
//   return (
//     <Routes>
//       <Route path="/" element={<Home />} />
//       <Route path="/signup" element={<Signup />} />
//       <Route path="/login" element={<Login />} />
//       <Route path="/auth/google/callback" element={<GoogleAuthCallback />} />
//       <Route path="/carbonfootprint" element={<CarbonFootprint />} />
//       <Route path="/UserDashBoard" element={<UserDashBoard />} />

//       {/* Admin layout with nested sidebar routes */}
//       <Route path="/AdminDashboard" element={<AdminDashboard />}>
//         <Route index element={<AdminOverview />} />
//         <Route path="certificates" element={<AdminCertificates />} />
//         <Route path="vehicles" element={<AdminVehicles />} />
//         <Route path="users" element={<AdminUsers />} />
//         <Route path="reports" element={<AdminReports />} />
//         <Route path="impact" element={<AdminImpact />} />
//         <Route path="downloads" element={<AdminDownloads />} />
//         <Route path="settings" element={<AdminSettings />} />
//       </Route>

//       <Route path="/ContactUs" element={<ContactUs />} />
//       <Route path="/ourteam" element={<OurTeam />} />
//       <Route path="/Facts" element={<Facts />} />
//     </Routes>
//   );
// };

// export default App;

// import React from "react";
// import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
// import { AuthProvider } from "./AuthContext";
// import Signup from "./pages/Signup";
// import Login from "./pages/Login";
// import GoogleAuthCallback from "./components/GoogleAuthCallback";
// import { Home } from "./pages/Home";
// import { Navbar } from "./components/Navbar";
// import { Footer } from "./components/Footer";
// import { CarbonFootprint } from "./pages/CarbonFootprint";
// import ContactUs from "./pages/ContactUs";
// import { UserDashBoard } from "./pages/UserDashBoard";

// import OurTeam from './pages/OurTeam';
// import Facts from './pages/Facts';
// import AdminDashboard from "./pages/AdminDashboard";

// function App() {
//   return (
//     <Router>
//       <AuthProvider>
//         <Layout />
//       </AuthProvider>
//     </Router>
//   );
// }

// // ✅ New component that decides whether to show Navbar/Footer
// const Layout = () => {
//   const location = useLocation();

//   // Add every route here where Navbar/Footer should be hidden
//   const hideLayoutRoutes = ["/AdminDashboard", "/UserDashBoard"];

//   const hideLayout = hideLayoutRoutes.includes(location.pathname);

//   return (
//     <>
//       {!hideLayout && <Navbar />}
//       <MainRoutes />
//       {!hideLayout && <Footer />}
//     </>
//   );
// };

// const MainRoutes = () => {
//   return (
//     <Routes>
//       <Route path="/" element={<Home />} />
//       <Route path="/signup" element={<Signup />} />
//       <Route path="/login" element={<Login />} />
//       <Route path="/auth/google/callback" element={<GoogleAuthCallback />} />
//       <Route path="/carbonfootprint" element={<CarbonFootprint />} />
//       <Route path="/UserDashBoard" element={<UserDashBoard />} />
//       <Route path="/AdminDashboard" element={<AdminDashboard />} />
//       <Route path="/ContactUs" element={<ContactUs />} />
//       <Route path="/ourteam" element={<OurTeam />} />
//       <Route path="/Facts" element={<Facts />} />
//     </Routes>
//   );
// };

// export default App;

// import React from "react";
// import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import { AuthProvider } from "./AuthContext";
// import Signup from "./pages/Signup";
// import Login from "./pages/Login";
// import GoogleAuthCallback from "./components/GoogleAuthCallback";
// import { Home } from "./pages/Home";
// import { Navbar } from "./components/Navbar";
// import { Footer } from "./components/Footer";
// import { CarbonFootprint } from "./pages/CarbonFootprint";
// import  ContactUs  from "./pages/ContactUs";
// import { UserDashBoard } from "./pages/UserDashBoard";

// import OurTeam from './pages/OurTeam';
// import Facts from './pages/Facts';
// import AdminDashboard from "./pages/AdminDashboard";

// function App() {
//   return (

//     <Router>
//       <AuthProvider> {/* ✅ Moved inside Router */}
//         <Navbar />
//         <MainRoutes />
//         <Footer />
//       </AuthProvider>
//     </Router>
//   );
// }

// const MainRoutes = () => {
//   // const { isLoggedIn } = useContext(AuthContext); // ✅ Get isLoggedIn state

//   return (
//     <Routes>
//       <Route path="/" element={<Home />} />
//       <Route path="/signup" element={<Signup />} />
//       <Route path="/login" element={<Login />} />
//       <Route path="/auth/google/callback" element={<GoogleAuthCallback />} />
//       <Route path="/carbonfootprint" element={<CarbonFootprint />} />
//       <Route path="/UserDashBoard" element={<UserDashBoard />} />
//       <Route path="/AdminDashboard" element={<AdminDashboard />} />
//       <Route path="/ContactUs" element={<ContactUs />} />
//       <Route path="/ourteam" element={<OurTeam />} />
//       <Route path="/Facts" element={<Facts />} />
//     </Routes>
//   );
// };

// export default App;